import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule } from '@angular/common/http';
import { DragulaModule } from 'ng2-dragula';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Network } from '@ionic-native/network';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';

import { MyApp } from './app.component';
import { LoadingPage } from '../pages/loading/loading';

import { LoginPage } from '../pages/login/login';
import { HomePage } from '../pages/home/home';
import { HistoryPage } from '../pages/history/history';
import { ConsultationPage } from '../pages/consultation/consultation';
import { DispensaryPage } from '../pages/dispensary/dispensary';
import { VerificationPage } from '../pages/verification/verification';
import { EditInfoPage } from '../pages/edit-info/edit-info';

import { PopoverQueuePage } from '../pages/popover-queue/popover-queue';
import { PopoverSymptomPage } from '../pages/popover-symptom/popover-symptom';
import { PopoverDxPage } from '../pages/popover-dx/popover-dx';

import { DataProvider } from '../providers/data/data';
import { ConsultationDataProvider } from '../providers/consultation-data/consultation-data';
import { ConsultationDisplayProvider } from '../providers/consultation-display/consultation-display';
import { ConsultationDataParserProvider } from '../providers/consultation-data-parser/consultation-data-parser';
import { PdfViewerProvider } from '../providers/pdf-viewer/pdf-viewer';
import { DispLabelProvider } from '../providers/disp-label/disp-label';
import { MedicalCertProvider } from '../providers/medical-cert/medical-cert';
import { ConsultationHistoryProvider } from '../providers/cons-history/cons-history';
import { SickLeaveProvider } from '../providers/sick-leave/sick-leave';
import { PrescriptionProvider } from '../providers/prescription/prescription';

import { ConstantsProvider } from '../providers/constants/constants';
import { CloudDataProvider } from '../providers/cloud-data/cloud-data';
import { HelperProvider } from '../providers/helper/helper';

import { PopoverQuantityPage } from '../pages/popover-quantity/popover-quantity';
import { PopoverDaysPage } from '../pages/popover-days/popover-days';
import { PopoverHidePage } from '../pages/popover-hide/popover-hide';

import { DropdownDatePage } from '../pages/dropdown-date/dropdown-date';
import { DropdownPopoverPage } from '../pages/dropdown-popover/dropdown-popover';
import { PopoverSignPage } from '../pages/popover-sign/popover-sign';

import { SignaturePage } from '../pages/signature/signature';
import {PrintPage} from "../pages/print/print";
import {HistoryPageDisp} from "../pages/history-disp/history-disp";
import {UsagePage} from "../pages/usage/usage";

@NgModule({
   declarations:
   [
      MyApp,
      LoadingPage,
      LoginPage,
      HomePage,
      HistoryPage,
      ConsultationPage,
      DispensaryPage,
      PopoverQueuePage,
      PopoverSymptomPage,
      PopoverDxPage,
      PopoverQuantityPage,
      PopoverDaysPage,
      PopoverHidePage,
      VerificationPage,
      SignaturePage,
      PopoverSignPage,
      DropdownDatePage,
      DropdownPopoverPage,
      EditInfoPage,
      PrintPage,
      HistoryPageDisp,
      UsagePage
   ],
   imports:
   [
      BrowserModule,
      HttpClientModule,
      IonicModule.forRoot( MyApp ),
      IonicStorageModule.forRoot(),
      DragulaModule.forRoot()
   ],
   bootstrap: [ IonicApp ],
   entryComponents:
   [
      MyApp,
      LoadingPage,
      LoginPage,
      HomePage,
      HistoryPage,
      ConsultationPage,
      DispensaryPage,
      PopoverQueuePage,
      PopoverSymptomPage,
      PopoverDxPage,
      PopoverQuantityPage,
      PopoverDaysPage,
      PopoverHidePage,
      VerificationPage,
      SignaturePage,
      PopoverSignPage,
      DropdownDatePage,
      DropdownPopoverPage,
      EditInfoPage
   ],
   providers:
   [
      StatusBar,
      SplashScreen,
      Network,
      File,
      FileOpener,
      { provide: ErrorHandler, useClass: IonicErrorHandler },
      DataProvider,
      ConstantsProvider,
      CloudDataProvider,
      HelperProvider,
      ConsultationDataProvider,
      ConsultationDisplayProvider,
      ConsultationDataParserProvider,
      PdfViewerProvider,
      DispLabelProvider,
      ConsultationHistoryProvider,
      MedicalCertProvider,
      SickLeaveProvider,
      PrescriptionProvider
   ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts